// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tl7C","title":"styles_title__2VhhZ"};